import { date } from 'quasar'
import * as Enumerable from 'linq-es2015'


export default {
    props: {
        index: Number,
        modelId: Object,
        modelObject: Object,
        actionLabel: String,
        actionTitle: String,
        editMode: Boolean,
        parentScreenParameters: Object
    },

    mixins: [],

    components: {
        
    },

    data: function () {
        return {
            screenKey: "FreshDeskTicketListFilterModel",
            loading: false,
            actionLocked: false,
            model: this.emptyModel(),
            modelErrors: null,
            modelMetadata: {
                
            },
            
            applicationResources: null,
            toolTipStates: {},
            dataSourceFreshDeskTicketDateRangeType: [],
            dataSourceFreshDeskTicketStatus: [],

        }
    },

    computed: {
        screenTitle: function () {
            return 'Filter';
        },

        
    },

    methods: {
        fieldHasError: function (field) {
            return this.modelErrors != null && this.modelErrors.hasOwnProperty(field);
        },

        fieldErrorMessage: function (field) {
            if (this.modelErrors == null) {
                return '';
            }

            if (this.modelErrors.hasOwnProperty(field) === false) {
                return '';
            }
            
            return this.modelErrors[field];
        },

        

        emptyModel() {
            return {
                Status: null,
                LastTicketUpdateDateRange: null,

            }
        },

        onFreshDeskTicketDateRangeTypeStaticDataSource() {
            this.dataSourceFreshDeskTicketDateRangeType = JSON.parse('[{"Key":0,"Value":"This Week"},{"Key":1,"Value":"This Month"},{"Key":2,"Value":"Last Two Months"}]');
        },

        onFreshDeskTicketStatusStaticDataSource() {
            this.dataSourceFreshDeskTicketStatus = JSON.parse('[{"Key":0,"Value":"Active"},{"Key":1,"Value":"Closed"}]');
        },

        onLastTicketUpdateDateRangeChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value?.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceFreshDeskTicketDateRangeType).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    if (dsItem.hasOwnProperty('Item'))
                        valueItem = dsItem.Item;
                    else if (dsItem.hasOwnProperty('Value'))
                        valueItem = dsItem.Value;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        onStatusChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value?.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceFreshDeskTicketStatus).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    if (dsItem.hasOwnProperty('Item'))
                        valueItem = dsItem.Item;
                    else if (dsItem.hasOwnProperty('Value'))
                        valueItem = dsItem.Value;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        
        onLoadFieldDataSources() {
            this.onFreshDeskTicketDateRangeTypeStaticDataSource();
            this.onFreshDeskTicketStatusStaticDataSource();

        },

        async show() {
            if (this.modelObject && this.modelObject.Id > 0)
                {
                    // Edit
                    this.model = this.emptyModel();
                    this.model.Id = this.modelObject.Id;
                    this.$applyModelFields(this.modelObject, this.model);
                } else {
                    // Create
                    this.model = this.emptyModel();
                    this.$applyModelFields(this.modelObject, this.model);
                }

                this.onLoadFieldDataSources();
            this.$refs.dialog.show();
        },

        hide() {
            this.$refs.dialog.hide();
        },

        async onDialogHide() {
            this.$emit('hide');
            
        },

        async onOkClick() {
            if(this.actionLocked)
                return;
            try {
                this.actionLocked = true;
                let validateResult = await this.$refs.modelForm.validate();
                if (validateResult) {
                    this.$emit('ok', { index: this.index, model: this.model, files: null });
                    this.hide();
                }
            }
            finally {
                this.actionLocked = false;
            }
        },

        onCancelClick() {
            this.hide();
        }
    }
}